module.exports = __webpack_public_path__ + "img/fmcs_jiagou.472f8451.png";